<div id="cart-container" [ngClass]="{'select-mean-page': pageName === 'select-pay'}">
  <div>
    <div *ngIf="pageName === 'select-pay'" id="cart-header">
      En résumé
    </div>
    <div id="cart-content">
      <div *ngIf="pageName === 'balance-outstanding'" class="cart-subtitle">
        <span *ngIf="cartContent.DetailPanier.length <= 1"> {{ cartContent.DetailPanier.length }} pièce sélectionnée
        </span>
        <span *ngIf="cartContent.DetailPanier.length > 1"> {{ cartContent.DetailPanier.length }} pièces sélectionnées
        </span>
      </div>

      <div *ngIf="pageName === 'select-pay' && panierService.getPiecesByType(TypePiece.FACTURE).length > 0">
        <div class="cart-subtitle">
          <span *ngIf="panierService.getPiecesByType(TypePiece.FACTURE).length === 1"> {{
            panierService.getPiecesByType(TypePiece.FACTURE).length }} facture sélectionnée </span>
          <span *ngIf="panierService.getPiecesByType(TypePiece.FACTURE).length > 1"> {{
            panierService.getPiecesByType(TypePiece.FACTURE).length }} factures sélectionnées </span>
        </div>
        <ul>
          <li *ngFor="let facture of panierService.getPiecesByType(TypePiece.FACTURE)">
            <span class="li-label">Facture N° {{facture.NumPiece}}</span>
            <span> <b> &nbsp;{{facture.Montant | currency: 'EUR' : 'symbol' :'1.2-2'}} </b> </span>
          </li>
        </ul>
      </div>

      <div *ngIf="pageName === 'select-pay' && panierService.getPiecesByType(TypePiece.AVOIR).length > 0">
        <div class="cart-subtitle">
          <span *ngIf="panierService.getPiecesByType(TypePiece.AVOIR).length === 1"> {{
            panierService.getPiecesByType(TypePiece.AVOIR).length }} avoir sélectionné </span>
          <span *ngIf="panierService.getPiecesByType(TypePiece.AVOIR).length > 1"> {{
            panierService.getPiecesByType(TypePiece.AVOIR).length }} avoirs sélectionnés </span>
        </div>
        <ul>
          <li *ngFor="let avoir of panierService.getPiecesByType(TypePiece.AVOIR)">
            <span class="li-label">Avoir N° {{avoir.NumPiece}}</span>
            <span> <b> &nbsp;{{avoir.Solde | currency: 'EUR' : 'symbol' :'1.2-2'}} </b> </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div id="cart-footer" [ngClass]="{'is-payment-mean-page': pageName === 'select-pay'}">
    <div id="total-row">
      <div class="total-label">Montant total</div>
      <div class="total-amount-currency" [ngClass]="{ 'read-only': inputDisabled, 'amount-error':  errorOnAmount }">
        <input [disabled]="inputDisabled" data-testid="balance-outstanding-input-amount"
          [ngModel]="cartAmount | number: '1.2-2'" (keyup)="cartAmountChange.next($event.target.value)">
        <div class="total-currency"> € <sup>TTC</sup> </div>
      </div>
    </div>
    <button class="ui-btn primary-btn" data-testid="basket-payment-button" (click)="clickPay.emit()"
      [disabled]="payDisabled" [ngClass]="{ 'no-pay-right': !hasPayRight }">Payer</button>
  </div>
</div>
